exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".md-section[data-v-499302f6]{padding-top:0}.image-style[data-v-499302f6]{padding:10px 0 10px 10px}.column-in-center[data-v-499302f6]{margin-left:60px}.image-box.style9 figure img[data-v-499302f6]{width:50%}.icon-box.style5>i[data-v-499302f6],a.button[data-v-499302f6]{background:#ec008b}.icon-box.style5[data-v-499302f6]{background:#f5f5f5}.block[data-v-499302f6]{margin-bottom:20px}@media only screen and (min-device-width:768px) and (max-device-width:1024px){.column-in-center[data-v-499302f6]{margin-left:0}.icon-box.style5>i[data-v-499302f6]{width:80px;line-height:80px}.icon-box.style5[data-v-499302f6]{height:80px;line-height:80px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-499302f6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/forms/LuggageTab.vue
// module id = 309
// module chunks = 0